import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, FormFeedback } from "reactstrap";
import { withRouter } from "react-router";

import SelectPagination from "../../component/SelectPagination/SelectPagination";
import api from "../../config/api";
import historyAction from "../../redux/history/action";
import rsaAction from "../../redux/rsaPinDublicated/action";
import InputComp from "../../component/InputComp/InputComp";
import DatePicker from "../../component/DatePicker/DatePicker";
import constants from "../../config/constants";
import { splitUrl } from "../../config/helpers";

class Employer extends Component {
  state = {
    allStates: [],
    allLGA: [],
    sector: [],
    confirmEmployerPhone: "",
    pathname: "",
  };

  componentDidMount = async () => {
    const { customRef, history, setHistory } = this.props;

    this.fetchState(null, true);

    try {
      let response = await api.fetchAllSectors();
      let sectionList = response.data.result || [];
      const queryStrings = splitUrl(window.location.href)?.queryStrings || {};

      if (queryStrings.employerType === "MP") {
        this.props.setEmployerField({ employerType: "MP" });
        sectionList = sectionList.filter((item) => item.Code === "MP");
      }

      this.setState({
        sector: sectionList,
      });
    } catch (error) {
      console.log("E =>", error);
    }

    this.setState({
      pathname: history.location.pathname,
    });

    customRef({ validate: this.validate });
    setHistory(history);
  };

  onSelectChange = (e) => {
    const { setEmployerField } = this.props;

    setEmployerField({ [e.target.name]: e.target.value });

    if (e.target.name === "employerCountry") {
      this.fetchState(e.target.value);
    }

    if (e.target.name === "employerStatecode") {
      this.fetchLGA(e.target.value);
    }
  };

  fetchState = async (employerCountry, dontClear) => {
    try {
      const { setEmployerField, employerStatecode, token } = this.props;

      if (!dontClear) {
        setEmployerField({
          employerStatecode: "",
          employerLga: "",
        });
      }

      this.setState({ allStates: [], allLGA: [] });

      if (!employerCountry) {
        employerCountry = this.props.employerCountry;
      }

      if (employerStatecode) {
        this.fetchLGA(null, true);
      }

      const state = await api.fetchState(
        { countryCode: employerCountry },
        token
      );
      this.setState({ allStates: state.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchLGA = async (employerStatecode, dontClear) => {
    try {
      const { setEmployerField, token } = this.props;

      if (!dontClear) {
        setEmployerField({ employerLga: "" });
      }

      this.setState({ allLGA: [] });

      if (!employerStatecode) {
        employerStatecode = this.props.employerStatecode;
      }

      const LGA = await api.fetchLGA({ stateCode: employerStatecode }, token);

      this.setState({ allLGA: LGA.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  validate = () => {
    const {
      // employerBuildingNameOrNumber,
      // employerStreetName,
      employerBusiness,
      employerLga,
      employerStatecode,
      // employerNigeriaOrAbroad,
      employerType,
      dateOfFirstApointment,
      employerCity,
      // employerBox,
      // employerZip,
      employerPhone = "",
      stateOfPosting,
      employerLocation,
      employerCode,
      confirmEmployerPhone = "",
    } = this.props;

    let isValidated = true,
      // employerBuildingNameOrNumberError,
      // employerStreetNameError,
      employerBusinessError,
      employerLgaError,
      employerStatecodeError,
      // employerNigeriaOrAbroadError,
      employerTypeError,
      dateOfFirstApointmentError,
      employerCityError,
      employerZipError,
      employerBoxError,
      employerPhoneError,
      confirmEmployerPhoneError,
      stateOfPostingError,
      employerLocationError,
      employerCodeError;

    // if (!employerBuildingNameOrNumber) {
    //   employerBuildingNameOrNumberError = "This field is required";
    //   isValidated = false;
    // }
    // if (!employerStreetName) {
    //   employerStreetNameError = "This field is required";
    //   isValidated = false;
    // }
    if (this.state.pathname === constants.RSA_PIN_2_PATH) {
      if (confirmEmployerPhone !== employerPhone) {
        confirmEmployerPhoneError =
          "Confirm Employer Contact Phone and Employer's Contact Phone must be same";
        isValidated = false;
      }
    }
    if (!employerLocation) {
      employerLocationError = "This field is required";
      isValidated = false;
    }

    if (!employerCode) {
      employerCodeError = "This field is required";
      isValidated = false;
    }

    if (!employerBusiness) {
      employerBusinessError = "This field is required";
      isValidated = false;
    }

    if (!stateOfPosting) {
      stateOfPostingError = "This field is required";
      isValidated = false;
    }

    if (!employerCity) {
      employerCityError = "This field is required";
      isValidated = false;
    }

    if (!employerStatecode) {
      employerStatecodeError = "This field is required";
      isValidated = false;
    }

    if (!employerLga) {
      employerLgaError = "This field is required";
      isValidated = false;
    }

    // if (!employerNigeriaOrAbroad) {
    //   console.log("employerNigeriaOrAbroad")

    //   employerNigeriaOrAbroadError = "This field is required";
    //   isValidated = false;
    // }

    if (!employerType) {
      employerTypeError = "This field is required";
      isValidated = false;
    }

    if (employerType === "PU" && !dateOfFirstApointment) {
      dateOfFirstApointmentError = "This field is required";
      isValidated = false;
    }

    // if (!employerBox) {
    //   employerBoxError = "This field is required";
    //   isValidated = false;
    // }

    // if (!employerZip) {
    //   employerZipError = "This field is required";
    //   isValidated = false;
    // }

    // if (!employerPhone) {
    //   employerPhoneError = "This field is required";
    //   isValidated = false;
    // }

    this.setState({
      // employerBuildingNameOrNumberError,
      // employerStreetNameError,
      employerBusinessError,
      employerStatecodeError,
      employerLgaError,
      employerCityError,
      // employerNigeriaOrAbroadError,
      employerTypeError,
      dateOfFirstApointmentError,
      employerZipError,
      employerBoxError,
      employerPhoneError,
      confirmEmployerPhoneError,
      stateOfPostingError,
      employerLocationError,
      employerCodeError,
    });

    return isValidated;
  };

  render() {
    const {
      employerType,
      setEmployerField,
      // employerCode,
      // employerBuildingNameOrNumber,
      employerCountry,
      employerLga,
      employerBusiness,
      // employerNigeriaOrAbroad,
      employerPhone,
      employerBox,
      employerStatecode,
      // employerStreetName,
      employerCity,
      employerZip,
      // dateOfCurrentEmployment,
      dateOfFirstApointment,
      employerAddress1,
      employerAddress,
      countries,
      stateOfPosting,
      allEmployers,
      employerCode,
      employerLocation,
      confirmEmployerPhone,
    } = this.props;

    const {
      allStates,
      allLGA,
      sector,
      // employerBuildingNameOrNumberError,
      // employerStreetNameError,
      employerBusinessError,
      employerStatecodeError,
      employerLgaError,
      // employerNigeriaOrAbroadError,
      // employerAddress1Error,
      // employerAddressError
      employerTypeError,
      dateOfFirstApointmentError,
      employerCityError,
      employerZipError,
      employerBoxError,
      employerPhoneError,
      confirmEmployerPhoneError,
      stateOfPostingError,
      isEmployerDropdown,
      employerLocationError,
      employerCodeError,
    } = this.state;
    const queryStrings = splitUrl(window.location.href)?.queryStrings || {};

    return (
      <div>
        <Input
          className="margin-y-10"
          type="select"
          name="employerType"
          id="exampleSelect"
          invalid={!!employerTypeError}
          value={employerType || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Sector of Employment*
          </option>
          {sector.map((item) => (
            <option key={Math.random().toString()} value={item.Code}>
              {item.SectorName}
            </option>
          ))}
        </Input>

        {!!employerTypeError && (
          <FormFeedback>{employerTypeError}</FormFeedback>
        )}
        <SelectPagination
          containerClasses="my-2"
          isOpen={isEmployerDropdown}
          placeholder={
            this.state.pathname === constants.RSA_PIN_2_PATH
              ? "Employer"
              : "Employer Code"
          }
          errorMessage={employerCodeError}
          onToggle={(isEmployerDropdown) =>
            this.setState({ isEmployerDropdown })
          }
          allOptions={allEmployers}
          lookFor="EmployerName"
          value={employerCode}
          key="EmployerCode"
          onSelect={(item) => {
            setEmployerField({
              employerCode: item.EmployerName,
              employerRawCode: item.EmployerCode,
            });

            this.setState({ isEmployerDropdown: false });
          }}
        />
        {/* <InputComp
          type="text"
          value={employerType}
          placeholder="Sector of Employment"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setEmployerField({ employerType: e.target.value });
          }}
        /> */}
        {/* <InputComp
          type="text"
          value={employerCode}
          placeholder="Employer Code"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setEmployerField({ employerCode: e.target.value });
          }}
        /> */}
        {/* <InputComp
          type="text"
          value={employerBuildingNameOrNumber}
          placeholder="Employer Building Name / Number"
          containerStyles={{ width: "100%" }}
          errorMessage={employerBuildingNameOrNumberError}
          onChange={e => {
            setEmployerField({ employerBuildingNameOrNumber: e.target.value });
          }}
        /> */}
        {/* <InputComp
          type="text"
          value={employerStreetName}
          placeholder="Employer Street Name"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setEmployerField({ employerStreetName: e.target.value });
          }}
          errorMessage={employerStreetNameError}
        /> */}
        <InputComp
          type="text"
          value={employerCity}
          placeholder="Employer City"
          errorMessage={employerCityError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ employerCity: e.target.value });
          }}
        />
        <Input
          className="margin-y-10"
          type="select"
          name="employerCountry"
          id="exampleSelect"
          value={employerCountry || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Employer’s Country of Origin*
          </option>
          {countries.map((item) => (
            <option key={Math.random().toString()} value={item.countryCode}>
              {item.countryName}
            </option>
          ))}
        </Input>
        <Input
          className="margin-y-10"
          type="select"
          name="employerLocation"
          id="exampleSelect"
          invalid={!!employerLocationError}
          value={employerLocation || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Employer Location
          </option>
          <option value="N">Nigeria</option>
          <option value="A">Abroad</option>
        </Input>
        {!!employerLocationError && (
          <FormFeedback invalid>{employerLocationError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          type="select"
          name="employerStatecode"
          id="exampleSelect"
          invalid={!!employerStatecodeError}
          value={employerStatecode || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Employer State Code*
          </option>
          {allStates.map((item) => (
            <option key={Math.random().toString()} value={item.stateCode}>
              {item.stateName}
            </option>
          ))}
        </Input>
        {!!employerStatecodeError && (
          <FormFeedback invalid>{employerStatecodeError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          type="select"
          name="stateOfPosting"
          id="exampleSelect"
          invalid={!!stateOfPostingError}
          value={stateOfPosting || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            State Of Posting*
          </option>
          {allStates.map((item) => (
            <option key={Math.random().toString()} value={item.stateCode}>
              {item.stateName}
            </option>
          ))}
        </Input>
        {!!stateOfPostingError && (
          <FormFeedback invalid>{stateOfPostingError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          type="select"
          name="employerLga"
          id="exampleSelect"
          invalid={!!employerLgaError}
          value={employerLga || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Employer LGA*
          </option>
          {allLGA.map((item) => (
            <option key={Math.random().toString()} value={item.lgaCode}>
              {item.lgaName}
            </option>
          ))}
        </Input>
        {!!employerLgaError && (
          <FormFeedback invalid>{employerLgaError}</FormFeedback>
        )}
        <InputComp
          type="text"
          value={employerPhone}
          errorMessage={employerPhoneError}
          placeholder="Employer’s Contact phone"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ employerPhone: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={confirmEmployerPhone}
          errorMessage={confirmEmployerPhoneError}
          placeholder="Confirm Employer’s Contact phone"
          hidden={this.state.pathname !== constants.RSA_PIN_2_PATH}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ confirmEmployerPhone: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={employerBox}
          placeholder="Employer’s P.O. Box"
          errorMessage={employerBoxError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ employerBox: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={employerBusiness}
          errorMessage={employerBusinessError}
          placeholder="Employer Business*"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ employerBusiness: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={employerAddress1}
          placeholder="Employer’s Main Address"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ employerAddress1: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={employerAddress}
          placeholder="Employer’s Additional Address"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ employerAddress: e.target.value });
          }}
        />
        {/* <Input
          className="margin-y-10"
          type="select"
          name="employerNigeriaOrAbroad"
          invalid={!!employerNigeriaOrAbroadError}
          id="exampleSelect"
          value={employerNigeriaOrAbroad || "placeholder"}
          onChange={e => {
            setEmployerField({ employerNigeriaOrAbroad: e.target.value });
          }}
        >
          <option value="placeholder" disabled selected>
            Employer Nigeria Or Abroad*
          </option>
          <option value="N">Nigeria</option>
          <option value="A">Abroad</option>
        </Input> */}
        {/* {!!employerNigeriaOrAbroadError && (
          <FormFeedback invalid>{employerNigeriaOrAbroadError}</FormFeedback>
        )} */}
        <InputComp
          type="text"
          value={employerZip}
          placeholder="Employer’s ZIP Code*"
          errorMessage={employerZipError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setEmployerField({ employerZip: e.target.value });
          }}
        />
        <DatePicker
          value={dateOfFirstApointment}
          selected={dateOfFirstApointment}
          isError={dateOfFirstApointmentError ? true : false}
          errorMessage={dateOfFirstApointmentError}
          placeholder="First Appointment Date*"
          onChange={(e) => {
            setEmployerField({ dateOfFirstApointment: e });
          }}
          containerStyles={{ width: "100%" }}
        />
        {/* <InputComp
          type="text"
          value={dateOfCurrentEmployment}
          placeholder="Current Employment Date"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setEmployerField({ dateOfCurrentEmployment: e.target.value });
          }}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.rsaPinDublicated.employer,
  token: state.rsaPinDublicated.token,
  countries: state.onboarding.countries,
  allEmployers: state.auth.allEmployers,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setEmployerField: rsaAction.setEmployerField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Employer));
